<template>
    <div>


        <label for="">Batu</label>
        <div class="d-flex justify-content-end align-items-start pb-3">
            <b-button variant="pgiBtn" @click="$emit('addBatu')">
                <i class="fa fa-plus mr-1"></i>
                Tambah Batu
            </b-button>
        </div>
        <b-alert show variant="warning">
            Pengukur metmess hanya untuk batu berlian / zircon / permata (bukan batu berwarna)
        </b-alert>
        <div class="persentase-jasa-emas form-content-wrapper">
            <b-table borderless hover :busy="isBusy" :items="input.batu" :fields="fieldsBatu" responsive class="mb-3">

                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong> Loading data...</strong>
                    </div>
                </template>

                <template v-slot:cell(ukuran)="row">
                    <b-form-select name="ukuranBatu" v-model="row.item.ukuran">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled>-- Pilih Batu --</b-form-select-option>
                        </template>
                        <template>
                            <b-form-select-option v-for="item of batuOpt" :key="item.value" :value="{ name: item.name, value: item.value }">{{
                                item.name }}</b-form-select-option>
                        </template>
                    </b-form-select>
                    <b-input-group class="mt-2" v-if="row.item.ukuran == 99">
                        <b-col>
                            <b-row>
                                Masukan Ukuran
                            </b-row>
                            <b-row>
                                <b-form-input v-model="row.item.customUkuran" name="beratBasah" min="0" step="1"
                                    type="number"></b-form-input>
                            </b-row>
                        </b-col>
                    </b-input-group>
                </template>

                <template v-slot:cell(jumlah)="row">
                    <b-input-group>
                        <b-form-input v-model="row.item.jumlah" name="beratBasah" min="0" step="1"
                            type="number"></b-form-input>
                    </b-input-group>
                </template>

                <template v-slot:cell(action)="row">
                    <div class="no-wrap jasa-emas-action">
                        <b-button size="sm" class="table-button delete" v-b-tooltip.hover title="Hapus"
                            name="removeBeratJenis" @click="$emit('removeBatu', row.item.index)">
                            <i class="fa fa-trash"></i>
                        </b-button>
                    </div>
                </template>
            </b-table>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        input: { required: true },
        isBusy: { required: true },
        fieldsBatu: { required: true },
        batuOpt: { required: true },
    },
}
</script>